import { toast } from "react-hot-toast";
import { DEFAULT_TOAST_SHOW_DURATION, TOAST_TYPES } from "../constants";

const useCustomToast = () => {
  const showToast = (
    message: string,
    type: string,
    duration = DEFAULT_TOAST_SHOW_DURATION
  ) => {
    const options = {
      duration,
    };
    let toastId: any;
    if (type === TOAST_TYPES.ERROR) {
      toastId = toast.error(message, options);
    } else if (type === TOAST_TYPES.SUCCESS) {
      toastId = toast.success(message, options);
    } else {
      toastId = toast(message, options);
    }
    setTimeout(() => {
      toast.dismiss(toastId);
    }, duration);

    return toastId;
  };
  return showToast;
};

export default useCustomToast;
